/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleImportRequestReplaceModuleId } from './moduleImportRequestReplaceModuleId';
import type { ExportedModuleInput } from './exportedModuleInput';

/**
 * Request to import a module
 */
export interface ModuleImportRequest {
  replaceModuleId?: ModuleImportRequestReplaceModuleId;
  data: ExportedModuleInput;
}
